module.exports = {
          srcSet: __webpack_public_path__ + "e56475237d1fdf74e26f71b2aff20e41-19.png"+" 19w",
          images:[ {path: __webpack_public_path__ + "e56475237d1fdf74e26f71b2aff20e41-19.png",width: 19,height: 240}],
          src: __webpack_public_path__ + "e56475237d1fdf74e26f71b2aff20e41-19.png",
          toString:function(){return __webpack_public_path__ + "e56475237d1fdf74e26f71b2aff20e41-19.png"},
          
          width: 19,
          height: 240
        }